import { data } from '../../svg/FormatUnderlined/data';
import { makeIcon } from '../makeIcon';

export const FormatUnderlined = makeIcon(data, 'format_underlined', 'FormatUnderlined');

export default FormatUnderlined;
